// Many callers pass paths like "admin/api/v2/..." without a leading slash.
// On path-based routes (e.g. /media/{uuid}) the browser would resolve those
// against the current pathname, producing /media/admin/api/v2/... — so we
// normalize to an absolute path here unless the endpoint is already a full URL.
function normalizeEndpoint(endpoint) {
  if (/^https?:\/\//i.test(endpoint) || endpoint.startsWith('/')) return endpoint
  return '/' + endpoint
}

export default {
  getJSON(endpoint, success, error) {
    var xhr = new XMLHttpRequest();

    xhr.open('GET', normalizeEndpoint(endpoint));

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if(xhr.status == 200) {
          let data = JSON.parse(xhr.responseText);
          success(data);
        }
        else {
          if(error) {
            error(xhr.status, xhr.responseText);
          }
        }
      }
    };

  },

  postJSON(endpoint, data, success, error) {
    var xhr = new XMLHttpRequest();
    var body = JSON.stringify(data);

    xhr.open('POST', normalizeEndpoint(endpoint), true);

    xhr.setRequestHeader('Content-type', 'application/json');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if(xhr.status == 200) {
          let data = JSON.parse(xhr.responseText);
          success(data);
        }
        else {
          if(error) {
            error(xhr.status, xhr.responseText);
          }
        }
      }
    };

    xhr.send(body);
  }
}